import { setupStimulus } from '@blueberry/framework/setup_stimulus'

import '@hotwired/turbo'
import './base.css'

setupStimulus(
  import.meta.glob('./controllers/*_controller.ts', { eager: true }),
)
